// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Addon } from './addon';
import { AddonDoc } from './addon-doc';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AddonDocMap extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key FK addon */
  addonId!: number;
  /** Int32 key FK addonDoc */
  addonDocId!: number;
  /** FK addonId */
  addon!: Addon;
  /** FK addonDocId */
  addonDoc!: AddonDoc;
}

